import Home from "./pages/homepage/Home";
import { 
  BrowserRouter,
  Routes,
  Route
} from 'react-router-dom'
import Menu from "./pages/menupage/Menu";
import Contact from "./pages/contactpage/Contact";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/cardapio' element={<Menu />} />
        <Route path='/contato' element={<Contact />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
